import api from "./api";

const KEYS = {
  COLUMNS: "myleads.columns",
  DENSITY: "myleads.density",
  QUICK_FILTERS: "myleads.quickFilters",
  LAST_EXPORT: "myleads.lastExportFormat",
  ACTIVE_VIEW: "myleads.activeView",
};

/**
 * Backend returns { data: { key, value } }.
 * We always unwrap to just the value.
 */
function unwrap(res) {
  if (!res || typeof res !== "object") return res ?? null;
  if (res.data && typeof res.data === "object" && "value" in res.data) {
    return res.data.value;
  }
  if ("value" in res) return res.value;
  return res;
}

async function getAll() {
  try {
    const res = await api.getUserPreferences?.();
    const payload = res?.data || res || {};
    // payload is { key: value, key: value }
    return payload;
  } catch {
    return {};
  }
}

async function get(key) {
  try {
    const res = await api.getUserPreference?.(key);
    return unwrap(res);
  } catch {
    return null;
  }
}

async function set(key, value) {
  try {
    const res = await api.setUserPreference?.(key, value);
    return unwrap(res);
  } catch {
    return null;
  }
}

export default { KEYS, getAll, get, set };